import React from 'react';
import { PACKAGE_STEPS, getStepIndex, getLevelStyles } from '@/data/packageData';

const PackageStepIndicator = ({ pkg, currentStepKey }) => {
  const currentIndex = getStepIndex(currentStepKey);
  const currentStep = PACKAGE_STEPS[currentIndex];
  const levelStyles = pkg ? getLevelStyles(pkg.colorKey) : {};

  const fmt = (n) => String(n).padStart(2, '0');

  return (
    <footer className="py-5 px-4">
      <div className="flex flex-col items-center gap-2">
        {/* Step title */}
        {currentStep && (
          <div className="text-[1.1rem] font-semibold tracking-wide uppercase text-foreground">
            {currentStep.label}
          </div>
        )}

        <div className="flex justify-center items-center gap-3">
          {/* Step dots */}
          <div className="flex items-center gap-2">
            {PACKAGE_STEPS.map((step, index) => (
              <div
                key={step.key}
                className={`h-2 rounded-full transition-all duration-300 ${
                  index === currentIndex
                    ? 'w-8 bg-accent'
                    : index < currentIndex
                    ? 'w-2 bg-accent/50'
                    : 'w-2 bg-muted-foreground/30'
                }`}
              />
            ))}
          </div>

          {/* Page number */}
          <div className="ml-4 text-base font-medium tracking-wide text-muted-foreground">
            Page{' '}
            <span className="text-foreground font-semibold">{fmt(currentIndex + 1)}</span>
            {' '}of{' '}
            <span className="text-foreground font-semibold">{fmt(PACKAGE_STEPS.length)}</span>
          </div>
        </div>

        {/* Package badge */}
        {pkg && (
          <div
            className="text-xs font-semibold px-3 py-1 rounded-full mt-1"
            style={levelStyles}
          >
            {pkg.fullName}
          </div>
        )}
      </div>
    </footer>
  );
};

export default PackageStepIndicator;
